import React, { ReactElement } from 'react'

import image from '@lib/image'

interface CarrierLogoProps {
  code: string
  logo?: string
}

const CarrierLogo = ({ code, logo }: CarrierLogoProps): ReactElement => (
  <div className="journey-card__header-logo">
    <img
      key={code}
      src={logo ?? image.getMarketingCarrierLogo(code)}
      className="journey-card__header-logo-img"
      alt="carrier logo"
    />
  </div>
)

export default CarrierLogo
